import { CartSku, StoreService } from '@common/contracts/server/ostin/api';

import type { IVariantInterval, IVariantIntervalsTime } from './fromDeliveryVariantsToIntervals';

export interface IDeliverySelectedDate {
  dateFrom: string;
  dateTo: string;
  dateId: string;
  interval: string | undefined;
  intervalId: string | undefined;
  productCount: number | undefined;
  freeShipping: boolean | undefined;
  shippingPrice: string | undefined;
  skus: CartSku[];
  needPrepay: boolean,
  services: StoreService[],
}

export function getDeliverySelectedDate(
  date: IVariantInterval,
  selectedInterval: IVariantIntervalsTime,
): IDeliverySelectedDate {
  return {
    dateFrom: date.dateFrom,
    dateTo: date.dateTo,
    dateId: date.id,
    interval: selectedInterval.value,
    intervalId: selectedInterval.id,
    productCount: selectedInterval.productCount,
    freeShipping: selectedInterval.freeShipping,
    shippingPrice: selectedInterval.shippingPrice,
    skus: selectedInterval.skus,
    needPrepay: date.needPrepay || false,
    services: date.services || [],
  };
}
